import type { ComponentType } from "react";
import type { IntegrationKind } from "scantling-common";
import { Registry } from "scantling-common";

export interface IntegrationConfigProps {
  config: Record<string, unknown>;
  update: (newConfig: Record<string, unknown>) => void;
}

export interface IntegrationStatusProps {
  connected: boolean;
  error?: string;
}

export interface IntegrationProviderComponent {
  type: string;
  kind: IntegrationKind;
  label: string;
  icon: ComponentType;
  ConfigEditor: ComponentType<IntegrationConfigProps>;
  StatusDisplay: ComponentType<IntegrationStatusProps>;
}

export const integrationProviderRegistry =
  new Registry<IntegrationProviderComponent>();

export function getIntegrationProvider(
  type: string,
): IntegrationProviderComponent | undefined {
  return integrationProviderRegistry.get(type);
}

export function getIntegrationProviders(): IntegrationProviderComponent[] {
  return integrationProviderRegistry.getAll();
}

export function getIntegrationProvidersByKind(
  kind: IntegrationKind,
): IntegrationProviderComponent[] {
  return integrationProviderRegistry.getAll().filter(p => p.kind === kind);
}
